import React from 'react';

// 基础骨架加载组件 (内部使用)
// const SkeletonBox = ({ width = 'w-full', height = 'h-4', rounded = 'rounded' }) => (
//     <div className={`${width} ${height} ${rounded} bg-gray-200 animate-pulse`}></div>
// );

// 表格行骨架
export const TableRowSkeleton = ({ columns = 6, showAdmin = false }) => (
    <tr className="animate-pulse">
        {showAdmin && (
            <td className="px-4 py-4 whitespace-nowrap">
                <div className="w-8 h-8 bg-gray-200 rounded-full mx-auto"></div>
            </td>
        )}
        {Array(columns).fill(0).map((_, index) => (
            <td key={index} className="px-6 py-4 whitespace-nowrap">
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            </td>
        ))}
        <td className="px-6 py-4 whitespace-nowrap text-right">
            <div className="flex justify-end space-x-2">
                <div className="w-12 h-6 bg-gray-200 rounded"></div>
                <div className="w-12 h-6 bg-gray-200 rounded"></div>
                <div className="w-12 h-6 bg-gray-200 rounded"></div>
            </div>
        </td>
    </tr>
);

// 表格骨架
export const TableSkeleton = ({ rows = 5, columns = 6, showAdmin = false }) => (
    <div className="talent-table-container bg-white shadow-lg rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
            <table className="talent-table min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        {showAdmin && (
                            <th className="px-4 py-3 text-center">
                                <div className="w-8 h-4 bg-gray-300 rounded mx-auto"></div>
                            </th>
                        )}
                        {Array(columns).fill(0).map((_, index) => (
                            <th key={index} className="px-6 py-3 text-left">
                                <div className="h-4 bg-gray-300 rounded w-20"></div>
                            </th>
                        ))}
                        <th className="px-6 py-3 text-center">
                            <div className="h-4 bg-gray-300 rounded w-16 mx-auto"></div>
                        </th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {Array(rows).fill(0).map((_, index) => (
                        <TableRowSkeleton 
                            key={index} 
                            columns={columns} 
                            showAdmin={showAdmin}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    </div>
);

// 卡片骨架
export const CardSkeleton = ({ showStats = true }) => (
    <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
        <div className="flex items-center justify-between mb-4">
            <div className="h-6 bg-gray-200 rounded w-1/3"></div>
            <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
        </div>
        {showStats && (
            <div className="space-y-3">
                <div className="h-8 bg-gray-200 rounded w-1/2"></div>
                <div className="h-4 bg-gray-200 rounded w-2/3"></div>
            </div>
        )}
    </div>
);

// 详情模态框骨架
export const DetailModalSkeleton = () => (
    <div className="modal-container fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
        <div className="modal-content bg-white rounded-lg shadow-xl w-full max-w-4xl animate-pulse">
            {/* Header */}
            <div className="modal-header p-6 border-b">
                <div className="flex items-center justify-between">
                    <div className="h-8 bg-gray-200 rounded w-48"></div>
                    <div className="w-6 h-6 bg-gray-200 rounded"></div>
                </div>
            </div>
            
            {/* Body */}
            <div className="modal-body p-6">
                {/* Tab navigation */}
                <div className="flex space-x-4 mb-6">
                    <div className="h-10 bg-gray-200 rounded w-20"></div>
                    <div className="h-10 bg-gray-200 rounded w-24"></div>
                    <div className="h-10 bg-gray-200 rounded w-20"></div>
                </div>
                
                {/* Content grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {Array(8).fill(0).map((_, index) => (
                        <div key={index} className="space-y-2">
                            <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                            <div className="h-6 bg-gray-200 rounded w-2/3"></div>
                        </div>
                    ))}
                </div>
            </div>
            
            {/* Footer */}
            <div className="modal-footer bg-gray-50 px-6 py-3 border-t">
                <div className="flex justify-end space-x-4">
                    <div className="h-10 bg-gray-200 rounded w-20"></div>
                    <div className="h-10 bg-gray-200 rounded w-24"></div>
                </div>
            </div>
        </div>
    </div>
);

// 表单骨架
export const FormSkeleton = () => (
    <div className="modal-container fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
        <div className="modal-content bg-white rounded-lg shadow-xl w-full max-w-4xl animate-pulse">
            {/* Header */}
            <div className="modal-header p-6 border-b">
                <div className="h-8 bg-gray-200 rounded w-40"></div>
            </div>
            
            {/* Body */}
            <div className="modal-body p-6">
                <div className="form-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {Array(12).fill(0).map((_, index) => (
                        <div key={index} className="space-y-2">
                            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                            <div className="h-10 bg-gray-200 rounded w-full"></div>
                        </div>
                    ))}
                </div>
            </div>
            
            {/* Footer */}
            <div className="modal-footer bg-gray-50 px-6 py-3 border-t">
                <div className="flex justify-end space-x-4">
                    <div className="h-10 bg-gray-200 rounded w-20"></div>
                    <div className="h-10 bg-gray-200 rounded w-20"></div>
                </div>
            </div>
        </div>
    </div>
);

// 地图骨架
export const MapSkeleton = () => (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden animate-pulse">
        {/* Map controls */}
        <div className="p-4 border-b bg-gray-50">
            <div className="flex flex-wrap gap-2 mb-4">
                <div className="h-8 bg-gray-200 rounded w-24"></div>
                <div className="h-8 bg-gray-200 rounded w-20"></div>
                <div className="h-8 bg-gray-200 rounded w-28"></div>
            </div>
        </div>
        
        {/* Stats cards */}
        <div className="p-4 grid grid-cols-2 md:grid-cols-4 gap-4 bg-gray-50 border-b">
            {Array(4).fill(0).map((_, index) => (
                <div key={index} className="text-center">
                    <div className="h-8 bg-gray-200 rounded w-12 mx-auto mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-16 mx-auto"></div>
                </div>
            ))}
        </div>
        
        {/* Map area */}
        <div className="h-96 bg-gray-200 relative">
            <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-gray-400 text-center">
                    <div className="w-16 h-16 bg-gray-300 rounded-full mx-auto mb-4"></div>
                    <div className="h-4 bg-gray-300 rounded w-32 mx-auto"></div>
                </div>
            </div>
        </div>
    </div>
);

// 通用加载状态
export const LoadingSpinner = ({ size = 'medium', text }) => {
    const sizeClasses = {
        small: 'w-4 h-4',
        medium: 'w-8 h-8',
        large: 'w-12 h-12'
    };
    
    return (
        <div className="flex items-center justify-center space-x-3">
            <div className={`${sizeClasses[size]} border-2 border-primary-200 border-t-primary-600 rounded-full animate-spin`}></div>
            {text && <span className="text-gray-600">{text}</span>}
        </div>
    );
};

// 导出骨架加载组件集合
const SkeletonComponents = {
    TableSkeleton,
    CardSkeleton,
    DetailModalSkeleton,
    FormSkeleton,
    MapSkeleton,
    LoadingSpinner
};

export default SkeletonComponents;